module.exports = __webpack_public_path__ + "53d6b738b25d8aec26e4f97cc18ef672.svg";